<template>
  <div class="head">
    <div class="main" v-for="(item, index) in item" :key="index">
      <!-- <div class="return-box">
        <i class="iconfont icon-back"></i>
        <span></span>
      </div> -->
      <h1>
        {{ item.customerName == "" ? "--" : item.customerName }}
        <span> {{ item.sex == "0" ? "女" : "男" }}·{{ item.age }}岁 </span>
      </h1>
      <div class="flex-auto">
        <div class="product-box">
          <p>检测产品</p>
          <h2>{{ item.productName }}</h2>
        </div>
        <div class="auto-box">
          <p>肿瘤样本编号</p>
          <h2>{{ item.labOriginalSampleNo }}</h2>
        </div>
      </div>
      <div class="edit-box">
        <div style="width: 52%">
          <p>病理诊断</p>
          <van-popover
            v-if="isInput"
            v-model="showPopover"
            trigger="click"
            placement="top-start"
          >
            <div class="pop-text">
              {{ item.sampleClinicopathologyRemarks }}
            </div>
            <template #reference>
              <h2>
                <span>{{ item.sampleClinicopathologyRemarks }}</span>
                <i @click="cancetEdit(item)" class="iconfont icon-bianji"></i>
              </h2>
            </template>
          </van-popover>
          <van-field
            ref="fieldPhone"
            :clickable="true"
            v-else
            clearable
            v-model="cancerVal"
            @blur="handleOnBlur(item)"
          />
        </div>
        <div style="width: 44%">
          <p>肿瘤样本采集日期</p>
          <h2>{{ /\d{4}-\d{1,2}-\d{1,2}/g.exec(item.sampleDate)[0] }}</h2>
        </div>
      </div>
      <!-- <div class="flex-auto" v-show="isShow">
        <div class="auto-box">
          <p>样本采集部位</p>
          <h2>----</h2>
        </div>
        <div class="auto-box">
          <p>样本类型</p>
          <h2>{{ item.sampleType }}</h2>
        </div>
        <div class="auto-box">
          <p>肿瘤样本编号</p>
          <h2>{{ item.labOriginalSampleNo }}</h2>
        </div>
        <div class="auto-box">
          <p>报告日期</p>
          <h2>{{ /\d{4}-\d{1,2}-\d{1,2}/g.exec(item.reportDate)[0] }}</h2>
        </div>
      </div> -->
    </div>
    <!-- <div class="icon-box" @click="isShow = !isShow">
      <i
        class="iconfont"
        :class="isShow ? 'icon-up_medium' : 'icon-down_medium'"
      ></i>
    </div> -->
    <div class="icon-box" @click="show = true">
      <i class="iconfont icon-right_medium"></i>
    </div>
    <div class="bottom"></div>
    <!-- 弹出框 -->
    <van-popup
      v-model="show"
      round
      closeable
      position="bottom"
      :style="{ height: '54%' }"
    >
      <div class="flex-box" v-for="(item, index) in item" :key="index">
        <div class="box">
          <p>用药史</p>
          <h1>{{item.usedDrugs}}</h1>
        </div>
        <div class="box">
          <p>肿瘤样本类型</p>
          <h1>{{item.sampleType}}</h1>
        </div>
        <div class="box">
          <p>处方医师</p>
          <h1>{{item.doctor}}</h1>
        </div>
        <div class="box">
          <p>肿瘤样本采集部位</p>
          <h1>{{item.samplePosition}}</h1>
        </div>
        <div class="box">
          <p>医疗机构</p>
          <h1>{{item.hospital}}</h1>
        </div>
        <div class="box">
          <p>对照样本类型</p>
          <h1>{{item.nSampleTypeOne}}</h1>
        </div>
        <div class="box">
          <p>肿瘤样本采集日期</p>
          <h1>{{ /\d{4}-\d{1,2}-\d{1,2}/g.exec(item.sampleDate)[0] }}</h1>
        </div>
        <div class="box">
          <p>对照样本采集日期</p>
          <h1>{{ /\d{4}-\d{1,2}-\d{1,2}/g.exec(item.normalSampleDate)[0] }}</h1>
        </div>
        <div class="box">
          <p>样本接收日期</p>
          <h1>{{ /\d{4}-\d{1,2}-\d{1,2}/g.exec(item.sampleAcceptDate)[0] }}</h1>
        </div>
      </div>
      <div class="tips">
        注：以上受检者基本信息来自患者送检时提供信息，而非来自本次检测结果，本次检测不对此内容进行解读。
      </div>
    </van-popup>
  </div>
</template>

<script>
import { updateDiagnoseResult } from "@/api/wxapi.js";
export default {
  props: {
    userData: {
      type: Array,
    },
  },
  data() {
    return {
      showPopover: false,
      height: 335,
      isShow: false,
      // cancerText: this.userData.sampleClinicopathologyRemarks,
      cancerVal: "",
      isInput: true,
      item: [],
      show: false,
    };
  },
  watch: {
    userData: function () {
      this.getTicket();
    },
  },
  mounted() {
    window.addEventListener("touchmove", this.myTouchMove, true);
  },
  methods: {
    async getTicket() {
      this.item = this.userData;
      console.log(this.item, "aaaaaaa");
    },
    myTouchMove() {
      if (!this.isInput) {
        this.$refs.fieldPhone.blur();
      }
    },
    handleOnBlur(item) {
      console.log(1111);
      this.isInput = true;
      if (this.cancerVal) {
        // item.sampleClinicopathologyRemarks = this.cancerVal;
        updateDiagnoseResult({
          labOriginalSampleNo: this.$route.query.fname,
          productCode: this.$route.query.fid,
          sampleClinicopathologyRemarks: this.cancerVal,
        }).then((res) => {
          this.$parent.getUserInfo();
        });
      }
    },
    cancetEdit(item) {
      console.log(item);
      this.cancerVal = item.sampleClinicopathologyRemarks;
      this.isInput = false;
      this.$nextTick(() => {
        this.$refs.fieldPhone[0].focus();
      });
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.van-popup {
  .van-icon{
    color: #2F354D;
    font-size: 18px;
  }
}
.tips {
  font-size: 11px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #a4a9bf;
  line-height: 16px;
  padding: 0 24px;
}
.flex-box {
  display: flex;
  flex-wrap: wrap;
  padding: 46px 24px 0;
  .box {
    width: 50%;
    min-width: 50%;
    margin-bottom: 20px;
    p {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #a4a9bf;
      line-height: 17px;
    }
    h1 {
      font-size: 13px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #2f354d;
      line-height: 18px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
}
.pop-text {
  font-size: 12px;
  color: #5f697d;
  padding: 10px;
}
.head {
  width: 100%;
  min-height: 275px;
  background: url("../../../assets/bg.png") no-repeat;
  background-size: 100% auto;
  position: relative;
  .main {
    padding: 55px 30px 0;
    .flex-auto {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      // padding-bottom: 50px;
      .auto-box {
        width: 44%;
        min-width: 44%;
        // margin-top: 20px;
        p {
          font-size: 12px;
          font-weight: 400;
          color: #d4d6dd;
          line-height: 17px;
        }
        h2 {
          font-size: 13px;
          font-weight: 500;
          color: #ffffff;
          line-height: 18px;
          margin-top: 4px;
        }
      }
    }
    .edit-box {
      display: flex;
      justify-content: space-between;

      /deep/.van-popover__wrapper {
        display: block;
      }
      /deep/.van-field {
        background: none !important;
        padding: 0;
        width: 85%;
        .van-field__control {
          font-size: 13px;
          font-weight: 500;
          color: #ffffff;
          caret-color: #4b84ff;
          border-radius: 0;
        }
        .van-field__control:focus {
          border-bottom: 1px solid #4b84ff;
        }
      }
      div {
        width: 50%;
      }
      p {
        font-size: 12px;
        font-weight: 400;
        color: #d4d6dd;
        line-height: 17px;
      }
      h2 {
        font-size: 13px;
        font-weight: 500;
        color: #ffffff;
        line-height: 18px;
        margin-top: 4px;
        display: flex;
        padding-right: 6px;
        span {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        i {
          min-width: 20px;
          font-size: 14px;
          color: #ffffff;
          margin-left: 4px;
        }
      }
    }
    .product-box {
      width: 52%;
      margin-bottom: 20px;
      p {
        font-size: 12px;
        font-weight: 400;
        color: #d4d6dd;
        line-height: 17px;
      }
      h2 {
        font-size: 13px;
        font-weight: 500;
        color: #2ae49e;
        line-height: 18px;
        margin-top: 4px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
    .return-box {
      margin-bottom: 34px;
      i {
        font-size: 18px;
        color: #ffffff;
        vertical-align: middle;
      }
      span {
        font-size: 15px;
        font-weight: 500;
        color: #ffffff;
        line-height: 22px;
        margin-left: 12px;
        vertical-align: middle;
      }
    }
    h1 {
      font-size: 26px;
      font-weight: 600;
      color: #ffffff;
      line-height: 38px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
      padding-bottom: 12px;
      margin-bottom: 24px;
      span {
        font-size: 12px;
        font-weight: 400;
        color: #d4d6dd;
        line-height: 17px;
      }
    }
  }
  .icon-box {
    position: absolute;
    right: 30px;
    bottom: 50px;
    width: 32px;
    height: 18px;
    background: #4b84ff;
    border-radius: 9px;
    text-align: center;
    line-height: 18px;
    i {
      font-size: 12px;
      color: #ffffff;
      vertical-align: middle;
    }
  }
  .bottom {
    width: 100%;
    height: 40px;
    background: url("../../../assets/radius.png") no-repeat;
    background-size: 100% auto;
    position: absolute;
    bottom: 0;
    z-index: 99;
  }
}
</style>
